import { render } from "./InformationPage.vue?vue&type=template&id=0e9e7b17&scoped=true"
const script = {}

import "./InformationPage.vue?vue&type=style&index=0&id=0e9e7b17&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e9e7b17"]])

export default __exports__